const telyApi = {}

const API = "https://minhately.tely.com.br/routerbox/ws/rbx_server_json.php";
const NEW_API = "https://tely.rbxsoft.com/routerbox/ws/rbx_server_json.php";

/**
 * requisição na API antiga da Tely
 * @param {object} dataReq - Dados da requisição conforme documentação da API da Tely
 * @param {function} callback {error, result} - Função callback recebe os dados retornados da API
 */
telyApi.makeRequest = (dataReq, callback) => {
  const request = new Request(API, { method: 'POST', body: JSON.stringify(dataReq) })

  fetch(request)
    .then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        throw new Error('Something went wrong on api server!');
      }
    })
    .then(response => {
      callback(response)
    }).catch(error => {
      callback({ error });
    });
}

/**
 * requisição na API antiga da Tely
 * @param {object} dataReq - Dados da requisição conforme documentação da API da Tely
 * @param {function} callback {error, result} - Função callback recebe os dados retornados da API
 */
telyApi.newMakeRequest = (dataReq, callback) => {
  const request = new Request(NEW_API, { method: 'POST', body: JSON.stringify(dataReq) })

  fetch(request)
    .then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        throw new Error('Something went wrong on api server!');
      }
    })
    .then(response => {
      callback(response)
    }).catch(error => {
      callback({ error });
    });
}

export default telyApi
